import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = {
  key: 0,
  class: "py-0"
}
const _hoisted_5 = { class: "text-success" }
const _hoisted_6 = { class: "currency mx-1 text-success fs-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("View ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-dark-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-2 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("invoices")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.invoices && _ctx.invoices.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Datatable, {
              "table-header": _ctx.tableHeader,
              "table-data": _ctx.invoices,
              "rows-per-page": 10,
              "enable-items-per-page-dropdown": true
            }, {
              "cell-rand_number": _withCtx(({ row: invoice }) => [
                _createTextVNode(" #" + _toDisplayString(invoice.rand_number), 1)
              ]),
              "cell-total_price": _withCtx(({ row: invoice }) => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(invoice.total_price), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$store.state.currency), 1)
              ]),
              "cell-status": _withCtx(({ row: invoice }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge text-capitalize", {
                'badge-success': invoice.status.slug === 'paid',
                'badge-danger': invoice.status.slug === 'canceled',
                'badge-warning': invoice.status.slug === 'pending',
              }])
                }, _toDisplayString(invoice.status.name), 3)
              ]),
              "cell-customer": _withCtx(({ row: invoice }) => [
                _createElementVNode("span", null, _toDisplayString(invoice.customer_name ? invoice.customer_name : "-"), 1)
              ]),
              "cell-release_date": _withCtx(({ row: invoice }) => [
                _createTextVNode(_toDisplayString(invoice.release_date), 1)
              ]),
              "cell-invoice": _withCtx(({ row: invoice }) => [
                _createVNode(_component_router_link, {
                  to: {
                name: 'invoice-view',
                params: {
                  id: invoice.id,
                },
              },
                  class: "btn btn-sm btn-light btn-active-light-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            }, 8, ["table-header", "table-data"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t("no_invoices_found")), 1)
            ])
          ]))
    ])
  ], 2))
}